var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFF",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    transform: "matrix(.69 0 0 .69 15.5 15.5)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13a.5.5 0 0 1-.353-.145C9.94 11.162 9 8.905 9 6.5s.94-4.662 2.647-6.355a.502.502 0 0 1 .705 0C14.06 1.839 15 4.096 15 6.5s-.94 4.662-2.647 6.355A.5.5 0 0 1 12 13zm0-11.773c-1.293 1.455-2 3.309-2 5.273s.707 3.818 2 5.273c1.293-1.455 2-3.309 2-5.273s-.707-3.818-2-5.273z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 16a.508.508 0 0 1-.186-.036L12 15.038l-2.314.926a.5.5 0 0 1-.623-.707l1.989-3.58a.501.501 0 0 1 .875.487l-1.307 2.351 1.193-.478a.487.487 0 0 1 .371 0l1.193.478-1.307-2.351a.5.5 0 0 1 .875-.487l1.989 3.58a.497.497 0 0 1-.062.573.489.489 0 0 1-.372.17zM12 5.999a9.05 9.05 0 0 1-2.52-.359.5.5 0 1 1 .28-.96 8.03 8.03 0 0 0 4.48 0 .5.5 0 1 1 .28.96 9.05 9.05 0 0 1-2.52.359zM12.52 4c-.275 0-.505-.224-.505-.5s.218-.5.495-.5h.01a.5.5 0 0 1 0 1zM6.5 8C5.673 8 5 7.327 5 6.5S5.673 5 6.5 5 8 5.673 8 6.5 7.327 8 6.5 8zm0-2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16c-1.654 0-3-1.346-3-3v-2.5a.5.5 0 0 1 .844-.363l1.5 1.42a.5.5 0 0 1-.687.727L2 11.662V13c0 1.103.897 2 2 2s2-.897 2-2V7.5a.5.5 0 0 1 1 0V13c0 1.654-1.346 3-3 3zM6.5 6a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-.5.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFish);
export default __webpack_public_path__ + "static/media/FISH.cb99d959137bc66bf6e3e7bab492aeab.svg";
export { ForwardRef as ReactComponent };